import { render, staticRenderFns } from "./lesson.vue?vue&type=template&id=0c10e44d"
import script from "./lesson.vue?vue&type=script&lang=js"
export * from "./lesson.vue?vue&type=script&lang=js"
import style0 from "./lesson.vue?vue&type=style&index=0&id=0c10e44d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports